import "@/index.css";
import { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { toast } from "sonner";
import { GameContainer } from "@/components/game";
import { SplashScreen } from "@/components/SplashScreen";
import { PWAInstallPrompt } from "@/components/PWAInstallPrompt";
import { VersionIndicator } from "@/components/VersionIndicator";
import { UpdateNotification } from "@/components/UpdateNotification";

function App() {
  const [showSplash, setShowSplash] = useState(true);

  // Dismiss any visible toast when the user taps/clicks anywhere on the screen.
  // This pairs with the profanity toast, which would otherwise linger.
  useEffect(() => {
    const dismissAll = () => toast.dismiss();
    document.addEventListener("pointerdown", dismissAll);
    return () => document.removeEventListener("pointerdown", dismissAll);
  }, []);

  // Track the actual *visual* viewport (accounts for pinch zoom, system text
  // scaling, soft keyboard) and expose it as CSS variables --vvw/--vvh on
  // <html>. Modals use these vars instead of vw/dvh so they never extend past
  // the visible area on Android devices where layout viewport != visual viewport.
  useEffect(() => {
    const root = document.documentElement;
    const update = () => {
      const vv = window.visualViewport;
      const w = vv ? vv.width : window.innerWidth;
      const h = vv ? vv.height : window.innerHeight;
      root.style.setProperty("--vvw", `${w}px`);
      root.style.setProperty("--vvh", `${h}px`);
    };
    update();
    const vv = window.visualViewport;
    if (vv) {
      vv.addEventListener("resize", update);
      vv.addEventListener("scroll", update);
    }
    window.addEventListener("resize", update);
    window.addEventListener("orientationchange", update);
    return () => {
      if (vv) {
        vv.removeEventListener("resize", update);
        vv.removeEventListener("scroll", update);
      }
      window.removeEventListener("resize", update);
      window.removeEventListener("orientationchange", update);
    };
  }, []);

  return (
    <div className="App">
      {showSplash && (
        <SplashScreen onComplete={() => setShowSplash(false)} />
      )}
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<GameContainer />} />
          <Route path="*" element={<GameContainer />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
      <PWAInstallPrompt />
      <VersionIndicator />
      <UpdateNotification />
    </div>
  );
}

export default App;
